import Vue from 'vue'
import VueRouter from 'vue-router'
// import comingSoon from '../views/comingSoon.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue')
  },
  {
    path: '/our-rooms',
    name: 'Our Rooms',
    component: () => import(/* webpackChunkName: "our-rooms" */ '../pages/our-rooms.vue')
  },
  {
    path: '/room/:id',
    name: 'Room',
    component: () => import(/* webpackChunkName: "room" */ '../pages/room.vue')
  },
  {
    path: '/meeting-room',
    name: 'Meeting Room',
    component: () => import(/* webpackChunkName: "meeting-room" */ '../pages/meeting-room.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import(/* webpackChunkName: "gallery" */ '../pages/gallery.vue')
  },
  {
    path: '/gallery/:id',
    name: 'Gallery',
    component: () => import(/* webpackChunkName: "gallery-details" */ '../pages/gallery-details.vue')
  },
  {
    path: '/journal',
    name: 'Journal',
    component: () => import(/* webpackChunkName: "journal" */ '../pages/journal.vue')
  },
  {
    path: '/promo',
    name: 'Promo',
    component: () => import(/* webpackChunkName: "promo" */ '../pages/promo.vue')
  },
  {
    path: "/journal/:id",
    component: () =>
      import(/* webpackChunkName: "journaldetails" */ "../pages/journal-details.vue"),
  },
  {
    path: "/promo/:id",
    component: () =>
      import(/* webpackChunkName: "promodetails" */ "../pages/promo-details.vue"),
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import(/* webpackChunkName: "contact-us" */ '../pages/contact-us.vue')
  },
  {
    path: '/my-account',
    name: 'My Account',
    component: () => import(/* webpackChunkName: "my-account" */ '../pages/my-account.vue')
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../pages/forgot-password.vue')
  },
  {
    path: '/book',
    name: 'Booking',
    component: () => import(/* webpackChunkName: "book" */ '../pages/book.vue')
  },
  {
    path: '/*',
    name: 'Error',
    component: () => import(/* webpackChunkName: "my-account" */ '../pages/404.vue')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
